import { useMutation } from "@tanstack/react-query";
import { useOktaAuth } from "@okta/okta-react";
import type { PatientInfoCheckData } from "../../../models/API/responseModels/patientInfoCheckResponse.model";
import { fetchPatientInfoCheck } from "../../patientInfoCheckApi";

/**
 * GET patient-info completeness for an uploaded document (Azure key / filepath).
 * Call from approvals after upload; also available via {@link fetchPatientInfoCheck} for non-hook callers.
 */
function useClassifyAnalyzeDocumentPatientInfoCheck() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["classifyAnalyzeDocumentPatientInfoCheck"],
    mutationFn: async (filepath: string): Promise<PatientInfoCheckData | undefined> => {
      const token = authState?.accessToken?.accessToken;
      if (!token) {
        throw new Error("You must be signed in to verify patient information.");
      }
      return fetchPatientInfoCheck(filepath, token);
    },
    retry: false,
  });
}

export default useClassifyAnalyzeDocumentPatientInfoCheck;
